import { GB, US, ZA } from 'country-flag-icons/react/3x2';
export const BestSellerTableData = {
  header: ['Best Seller', 'Date', 'Product', 'Country', 'Total', 'Status'],
  body: [
    {
      title: 'Ossim keter',
      subTitle: '2022',
      date: '16 Aug',
      product: 'Clothes',
      Country: <GB style={{ width: 25, height: 25 }} />,
      total: 158652,
      status: 'Success',
    },
    {
      title: 'Venter loren',
      subTitle: '2021',
      date: '21 Sep',
      product: 'Branded Shoes',
      Country: <US style={{ width: 25, height: 25 }} />,
      total: 95025,
      status: 'Success',
    },
    {
      title: 'Fran Loain',
      subTitle: '2022',
      date: '06 Mar',
      product: 'Electronics',
      Country: <ZA style={{ width: 25, height: 25 }} />,
      total: 90155,
      status: 'Success',
    },
  ],
};
